import React from "react";
import { useNavigate } from "react-router-dom";
import { StatusBar } from "../components/Shell";
import Ico from "../components/Ico";
import { useAppStore } from "../components/AppStore";
import { currentNeighbor } from "../mock";
import { ShieldCheck, Plus, Star, CalendarDays, Clock, DollarSign, MapPin } from "lucide-react";

export const jobStatusMeta = {
  open: { label: "Open · waiting for a Do'er", color: "#3b57c9", bg: "#eef2ff" },
  kid_accepted: { label: "Kid accepted · awaiting parent", color: "#e97f0c", bg: "#fdece0" },
  parent_approved: { label: "Approved & scheduled", color: "#3d8f34", bg: "#eaf6ea" },
  declined: { label: "Declined", color: "#e0533d", bg: "#fdece9" },
};

export default function NeighborHome() {
  const navigate = useNavigate();
  const { postedJobs } = useAppStore();
  const mine = postedJobs.filter((j) => !j.poster || j.poster === currentNeighbor.id);
  const scheduled = mine.filter((j) => j.status === "parent_approved");

  return (
    <div className="gd-screen bg-[#eef1fb]">
      <div className="flex-shrink-0 px-5 pb-6" style={{ background: "linear-gradient(160deg,#f5a63a,#e97f0c)", borderBottomLeftRadius: 28, borderBottomRightRadius: 28 }}>
        <StatusBar dark={false} />
        <div className="mt-1 flex items-center gap-3">
          <div className="grid h-12 w-12 place-items-center rounded-2xl bg-white/25 text-xl font-black text-white">{currentNeighbor.initial}</div>
          <div className="flex-1 text-white">
            <p className="text-xs font-semibold text-white/80">Neighbor · Poster</p>
            <p className="text-lg font-extrabold">{currentNeighbor.name}</p>
          </div>
          <span className="flex items-center gap-1 rounded-full bg-white/20 px-2.5 py-1 text-xs font-bold text-white"><Star size={12} fill="#fff" /> {currentNeighbor.rating.toFixed(1)}</span>
        </div>
        <div className="mt-3 flex items-center gap-2 rounded-2xl bg-white/15 p-3">
          <ShieldCheck size={20} className="text-white" />
          <div className="text-white">
            <p className="text-sm font-extrabold">Background Check Passed</p>
            <p className="text-[11px] text-white/80">Cleared by {currentNeighbor.bgProvider} · {currentNeighbor.bgClearedOn} — you're approved to post</p>
          </div>
        </div>
      </div>

      <div className="gd-scroll px-4 pb-28 gd-stagger">
        <button onClick={() => navigate("/post")} className="gd-orange-btn mt-4 flex w-full items-center justify-center gap-2 rounded-2xl py-4 text-base font-extrabold">
          <Plus size={20} /> Post a New Job
        </button>

        {/* poster calendar summary */}
        <div className="gd-card mt-4 p-4">
          <div className="mb-2 flex items-center gap-2 text-sm font-extrabold text-[#1f2a52]"><CalendarDays size={16} className="text-[#f5911e]" /> Your Scheduled Jobs</div>
          {scheduled.length === 0 ? (
            <p className="text-[12px] text-[#9aa3c0]">No scheduled jobs yet. Once a kid accepts and a parent approves, it lands here.</p>
          ) : (
            <div className="space-y-2">
              {scheduled.map((j) => (
                <div key={j.id} className="flex items-center gap-3 rounded-2xl bg-[#f7f8fd] p-2.5">
                  <div className="grid h-10 w-10 place-items-center rounded-xl" style={{ background: `${j.tint}18` }}><Ico name={j.icon} size={18} color={j.tint} /></div>
                  <div className="flex-1"><p className="text-[13px] font-bold text-[#1f2a52]">{j.title}</p><p className="text-[11px] font-semibold text-[#9aa3c0]">{j.schedule}</p></div>
                  <span className="text-sm font-black text-[#4fae3f]">${j.pay}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* my posted jobs */}
        <h3 className="mb-2 mt-5 text-base font-extrabold text-[#1f2a52]">My Posted Jobs</h3>
        <div className="space-y-3">
          {mine.map((j) => {
            const m = jobStatusMeta[j.status];
            return (
              <div key={j.id} className="gd-card p-4">
                <div className="flex items-center gap-3">
                  <div className="grid h-12 w-12 place-items-center rounded-2xl" style={{ background: `${j.tint}18` }}><Ico name={j.icon} size={22} color={j.tint} /></div>
                  <div className="flex-1">
                    <p className="text-sm font-extrabold text-[#1f2a52]">{j.title}</p>
                    <div className="mt-0.5 flex items-center gap-3 text-[10px] font-semibold text-[#9aa3c0]">
                      <span className="flex items-center gap-0.5"><DollarSign size={10} className="text-[#4fae3f]" />{j.pay}</span>
                      <span className="flex items-center gap-0.5"><Clock size={10} />{j.duration}</span>
                      <span className="flex items-center gap-0.5"><MapPin size={10} />{j.distance}</span>
                    </div>
                  </div>
                </div>
                <p className="mt-2 text-[11px] font-semibold text-[#9aa3c0]">{j.schedule}</p>
                <span className="mt-2 inline-block rounded-full px-2.5 py-1 text-[10px] font-bold" style={{ background: m.bg, color: m.color }}>{m.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
